export class GlobalLocation {
    id: number;
    status: string;
    name: string;
    description: string;
    primaryPhoneNumber: string;
    webAddress: string;
    address1: string;
    address2: string;
    city: string;
    state: string;
    zipCode: string;
    country: string;
    hours: string;
    fax: string;
    cleanZipCode: string;
    latitude: number | null;
    longitude: number | null;
    globalLocationId: number | null;
    helpfulTips: string;
}
